import { render } from "./LoadingVetDetails.vue?vue&type=template&id=77f66fd4&scoped=true&ts=true"
import script from "./LoadingVetDetails.vue?vue&type=script&lang=ts"
export * from "./LoadingVetDetails.vue?vue&type=script&lang=ts"

import "./LoadingVetDetails.vue?vue&type=style&index=0&id=77f66fd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f66fd4"]])

export default __exports__